const INDEX_COLORS = {
  0: "red",
  1: "blue",
  2: "green",
  3: "purple",
  4: "yellow",
  5: "orange",
};

const COLORS_INDEX = {
  red: 0,
  blue: 1,
  green: 2,
  purple: 3,
  yellow: 4,
  orange: 5,
};

export { INDEX_COLORS, COLORS_INDEX };
